export const MOTION_EDITOR_RESOURCE_DOMAIN =
  import.meta.env.VITE_API_DISAMBIGUATOR === '' ||
  import.meta.env.VITE_API_DISAMBIGUATOR === undefined
    ? 'https://resources.getcartwheel.com'
    : 'https://resources-staging.getcartwheel.com';
